export const tags = [
    { id: 'analyze', label: 'Content Analysis' },
    { id: 'entities', label: 'Entities' },
    { id: 'pages', label: 'Page Refreshes' },
    { id: 'lowCTR', label: 'Underperforming CTR' },
    // { id: 'all', label: 'All' },
];
